import { Link } from "react-router-dom";

const stats = [
  { value: "7", label: "竞技项目", icon: "ri-trophy-line" },
  { value: "24h", label: "资讯实时更新", icon: "ri-refresh-line" },
  { value: "500+", label: "每日赛事覆盖", icon: "ri-calendar-event-line" },
  { value: "100%", label: "赛果及时发布", icon: "ri-checkbox-circle-line" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-1.5 h-4 rounded-full bg-primary-500" />
            <span className="font-label text-xs tracking-[0.2em] uppercase text-primary-600">About This Site</span>
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight">
            51每日大赛
          </h1>
          <p className="mt-2 text-lg text-foreground-700">最新赛事资讯与比赛结果实时更新</p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            51每日大赛官网，提供全面的每日赛事信息覆盖各类竞技项目，实时发布比赛时间、赛程安排和最新比赛结果，
            方便用户快速了解赛事动态。无论你是体育爱好者、赛事关注者，还是体育从业人员与媒体，
            都能在这里第一时间获取每日赛事资讯与专题报道。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Link
              to="/events"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览全部赛事 <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center mb-3">
                <i className={`${s.icon} text-lg`} />
              </span>
              <div className="font-heading text-2xl md:text-3xl text-foreground-950">{s.value}</div>
              <div className="text-xs text-foreground-600 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}